<template>
  <BaseLink
    class="ui-tag-link"
    :class="[
      styled && `styled-${styled}`,
      `page-${serviceTypeValue}`,
      `text-overflow-${textOverflow}`
    ]"
    :to="url"
    :searchscroll="searchscroll"
  >
    <slot />
  </BaseLink>
</template>

<script lang="ts" setup>
const { serviceType } = useServiceType()

interface Props {
  url: string
  styled?: 'primary' | 'secondary' | 'tertiary' | 'none'
  serviceType?: 'hina' | 'jps'
  searchscroll?: boolean
  textOverflow?: 'wrap' | 'nowrap'
}
const props = withDefaults(defineProps<Props>(), {
  searchscroll: false,
  textOverflow: 'nowrap',
})

const serviceTypeValue = props.serviceType || serviceType
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.page-jps {
  --primary-background-color: #{$jps-gray-800};
  --primary-border-color: #{$jps-gray-800};
  --primary-text-color: #{$white};
  --primary-hover-text-color: #{$white-hover};

  --secondary-background-color: #{$jps-gray-800};
  --secondary-border-color: #{$jps-gray-800};
  --secondary-text-color: #{$white};
  --secondary-hover-text-color: #{$white-hover};

  --tertiary-background-color: #{$jps-sub-red};
  --tertiary-border-color: #{$jps-sub-red};
  --tertiary-text-color: #{$white};
  --tertiary-hover-text-color: #{$white-hover};
}

.page-hina {
  --primary-background-color: #{$hina-background-green};
  --primary-border-color: #{$hina-accent-green};
  --primary-text-color: #{$black};
  --primary-hover-text-color: #{$white-hover};

  --secondary-background-color: #{$hina-background-cream};
  --secondary-border-color: #{$hina-accent-yellow};
  --secondary-text-color: #{$black};
  --secondary-hover-text-color: #{$white-hover};

  --tertiary-background-color: #{$hina-accent-lime};
  --tertiary-border-color: #{$hina-accent-lime};
  --tertiary-text-color: #{$black};
  --tertiary-hover-text-color: #{$white-hover};
}

.ui-tag-link {
  @include tag-base;

  // ボタンスタイル
  &.styled-primary {
    border: 1px solid var(--primary-border-color);
    @include tag-color(
      var(--primary-background-color),
      var(--primary-border-color),
      var(--primary-text-color),
      var(--primary-hover-text-color)
    );
  }

  &.styled-secondary {
    border: 1px solid var(--secondary-border-color);
    @include tag-color(
      var(--secondary-background-color),
      var(--secondary-border-color),
      var(--secondary-text-color),
      var(--secondary-hover-text-color)
    );
  }

  &.styled-tertiary {
    border: 1px solid var(--tertiary-border-color);
    @include tag-color(
      var(--tertiary-background-color),
      var(--tertiary-border-color),
      var(--tertiary-text-color),
      var(--tertiary-hover-text-color)
    );
  }

  // テキストの折り返し
  &.text-overflow-nowrap {
  }

  &.text-overflow-wrap {
    white-space: normal;
  }
}
</style>